import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { ReactComponent as BSC } from '@frontend/assets/logo/bsc.svg';
import { ReactComponent as Polygon } from '@frontend/assets/logo/polygon.svg';
import { useMemo } from 'react';
export var LogoChain = function LogoChain(_ref) {
  var chainId = _ref.chainId;
  var logo = useMemo(function () {
    switch (Number(chainId)) {
      case 1:
        // eslint-disable-next-line @next/next/no-img-element
        return _jsx("img", {
          src: '/images/logo/eth.svg',
          alt: "eth"
        });

      case 56:
        return _jsx(BSC, {});

      case 137:
        return _jsx(Polygon, {});

      case 999:
        // eslint-disable-next-line @next/next/no-img-element
        return _jsx("img", {
          src: '/images/logo/terra.png',
          alt: "terra"
        });

      case 2020:
        // eslint-disable-next-line @next/next/no-img-element
        return _jsx("img", {
          src: '/images/logo/ronin.svg',
          alt: "ronin"
        });

      default:
        return null;
    }
  }, [chainId]);
  return _jsx(Frame, {
    children: logo
  });
};

var Frame = _styled("div", true ? {
  target: "ehxsotq0"
} : {
  target: "ehxsotq0",
  label: "Frame"
})(true ? {
  name: "163v8y6",
  styles: "width:28px;height:28px;margin-right:0.5rem;img{width:28px;height:28px;}"
} : {
  name: "163v8y6",
  styles: "width:28px;height:28px;margin-right:0.5rem;img{width:28px;height:28px;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92ZXJjZWwvcGF0aDAvYXBwcy9mcm9udGVuZC9zcmMvY29tcG9uZW50cy9Mb2dvQ2hhaW4vaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdDd0IiLCJmaWxlIjoiL3ZlcmNlbC9wYXRoMC9hcHBzL2Zyb250ZW5kL3NyYy9jb21wb25lbnRzL0xvZ29DaGFpbi9pbmRleC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IFJlYWN0Q29tcG9uZW50IGFzIEJTQyB9IGZyb20gJ0Bmcm9udGVuZC9hc3NldHMvbG9nby9ic2Muc3ZnJ1xuaW1wb3J0IHsgUmVhY3RDb21wb25lbnQgYXMgUG9seWdvbiB9IGZyb20gJ0Bmcm9udGVuZC9hc3NldHMvbG9nby9wb2x5Z29uLnN2ZydcbmltcG9ydCB7IHVzZU1lbW8gfSBmcm9tICdyZWFjdCdcblxuZXhwb3J0IHR5cGUgTG9nb0NoYWluUHJvcHMgPSB7XG4gIGNoYWluSWQ6IG51bWJlclxufVxuXG5leHBvcnQgY29uc3QgTG9nb0NoYWluOiBSZWFjdC5GQzxMb2dvQ2hhaW5Qcm9wcz4gPSAoeyBjaGFpbklkIH0pID0+IHtcbiAgY29uc3QgbG9nbyA9IHVzZU1lbW8oKCkgPT4ge1xuICAgIHN3aXRjaCAoTnVtYmVyKGNoYWluSWQpKSB7XG4gICAgICBjYXNlIDE6XG4gICAgICAgIC8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBAbmV4dC9uZXh0L25vLWltZy1lbGVtZW50XG4gICAgICAgIHJldHVybiA8aW1nIHNyYz17Jy9pbWFnZXMvbG9nby9ldGguc3ZnJ30gYWx0PVwiZXRoXCIgLz5cbiAgICAgIGNhc2UgNTY6XG4gICAgICAgIHJldHVybiA8QlNDIC8+XG4gICAgICBjYXNlIDEzNzpcbiAgICAgICAgcmV0dXJuIDxQb2x5Z29uIC8+XG4gICAgICBjYXNlIDk5OTpcbiAgICAgICAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEBuZXh0L25leHQvbm8taW1nLWVsZW1lbnRcbiAgICAgICAgcmV0dXJuIDxpbWcgc3JjPXsnL2ltYWdlcy9sb2dvL3RlcnJhLnBuZyd9IGFsdD1cInRlcnJhXCIgLz5cbiAgICAgIGNhc2UgMjAyMDpcbiAgICAgICAgLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEBuZXh0L25leHQvbm8taW1nLWVsZW1lbnRcbiAgICAgICAgcmV0dXJuIDxpbWcgc3JjPXsnL2ltYWdlcy9sb2dvL3JvbmluLnN2Zyd9IGFsdD1cInJvbmluXCIgLz5cbiAgICAgIGRlZmF1bHQ6XG4gICAgICAgIHJldHVybiBudWxsXG4gICAgfVxuICB9LCBbY2hhaW5JZF0pXG4gIHJldHVybiA8RnJhbWU+e2xvZ299PC9GcmFtZT5cbn1cblxuY29uc3QgRnJhbWUgPSBzdHlsZWQuZGl2YFxuICB3aWR0aDogMjhweDtcbiAgaGVpZ2h0OiAyOHB4O1xuICBtYXJnaW4tcmlnaHQ6IDAuNXJlbTtcbiAgaW1nIHtcbiAgICB3aWR0aDogMjhweDtcbiAgICBoZWlnaHQ6IDI4cHg7XG4gIH1cbmBcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});